import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "drop-shadow": [
        {
          "drop-shadow": ["0-0-10"],
        },
      ],
      "font-size": [
        {
          text: [
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "32",
            "34",
            "35",
            "40",
            "42",
            "48",
            "60",
            "80",
          ],
        },
      ],
      "inset-shadow": [
        {
          "inset-shadow": ["0-0-8"],
        },
      ],
      shadow: [
        {
          shadow: [
            "0-0-4",
            "0-0-8",
            "0-0-10",
            "0-0-10-5",
            "0-0-15",
            "0-0-20",
            "0-0-30",
            "0-3-5",
            "0-4-4",
            "0-4-8",
            "0-4-30",
            "0-10-20",
            "2-0-5-0",
            "9-6-4",
          ],
        },
      ],
      "text-shadow": [
        {
          "text-shadow": ["0-0-2", "0-0-6", "0-0-10", "0-0-20", "0-4-4"],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
